import Vue  from 'vue';
import VueRouter from 'vue-router';
import VueScrollTo from 'vue-scrollto';
import EventManager from 'dd-event-manager';
import $http from 'middleware/http';
import bootstrap from './bootstrap';
import ui   from './ui';
import rootOptions  from './dn';
import store from './store';
import dnAnalyticsTagLoader from 'util/dn-analytics-tag-loader';

// load bc-shared banner
window._bcSharedRootPath = store.getters['path/$join']('root', 'bc-shared');
require('../shared/bc-banner/bootstrap');

Vue.use(ui);
Vue.use(VueRouter);
Vue.use(VueScrollTo);

// Set for global
window.Vue = Vue;
window.EventManager = EventManager;
window.$http = $http;
window.dn = new Vue(rootOptions);
$(bootstrap);

dnAnalyticsTagLoader(dn);



// WEBPACK FOOTER //
// ./src/js/main.js